import type { FormField } from '@/types/formBuilder';
import {
  FEEDBACK_DETAILS_HELP_TEXT,
  FEEDBACK_DETAILS_MAX_CHARS,
  FEEDBACK_DETAILS_PLACEHOLDER,
} from './config';
import type { FeedbackOption } from './types';

export const FEEDBACK_OPTIONS_FIELD_ID = 'feedback-options';
export const FEEDBACK_DETAILS_FIELD_ID = 'feedback-details';

export const buildOptionsField = (options: FeedbackOption[]): FormField => ({
  id: FEEDBACK_OPTIONS_FIELD_ID,
  type: 'checkbox-group',
  name: 'reasons',
  label: '',
  required: true,
  order: 1,
  width: 'full',
  options: options.map((option) => ({
    label: option.label,
    value: option.value,
  })),
  cssClass: 'it-feedback-checkbox-group',
});

export const buildDetailsField = (): FormField => ({
  id: FEEDBACK_DETAILS_FIELD_ID,
  type: 'text',
  name: 'details',
  label: '',
  placeholder: FEEDBACK_DETAILS_PLACEHOLDER,
  helpText: FEEDBACK_DETAILS_HELP_TEXT,
  required: false,
  order: 2,
  width: 'full',
  validation: [
    {
      type: 'maxLength',
      value: FEEDBACK_DETAILS_MAX_CHARS,
    },
  ],
  cssClass: 'it-feedback-details-field',
});
